import React from "react";
import { useRef, useState } from 'react'
import TextField from "@material-ui/core/TextField";
import CallToActionButton from "components/shared/buttons/CallToActionButton";
import styled from 'styled-components'
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ArticleSharingMethod, useRecordArticleShared } from "hooks/analytics/useRecordArticleShared";

const LinkField = styled<any>(TextField).attrs({ className: "w-full" })``;

const CopyLinkField = styled<any>(CallToActionButton).attrs({ className: "w-full mt-1" })``;

export default ({ link, story }: { link: string, story?: any }) => {
	const [copied, setCopied] = useState(false);
    
	const recordArticleShared = useRecordArticleShared()

    return (
		<>
			<LinkField
				InputProps={{
					readOnly: true
				}}
				margin="dense"
				variant="outlined"
				value={link}
			/>
			<CopyToClipboard text={link} onCopy={() => {
				setCopied(true)
				if(story) {
					recordArticleShared(story, ArticleSharingMethod.link);
				}
			}}>
				<CopyLinkField>
					{copied ? "Copied!" : "Copy Link"}
				</CopyLinkField>
			</CopyToClipboard>
		</>
	);
}
	